"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendFiles;
exports.SEND_FILES = void 0;
var SEND_FILES = 'WEB_CHAT/SEND_FILES';
exports.SEND_FILES = SEND_FILES;

function sendFiles(files) {
  return {
    type: SEND_FILES,
    payload: {
      files: files
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRGaWxlcy5qcyJdLCJuYW1lcyI6WyJTRU5EX0ZJTEVTIiwic2VuZEZpbGVzIiwiZmlsZXMiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFVBQVUsR0FBRyxxQkFBbkI7OztBQUVlLFNBQVNDLFNBQVQsQ0FBbUJDLEtBQW5CLEVBQTBCO0FBQ3ZDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCxVQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxLQUFLLEVBQUxBO0FBQUY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRU5EX0ZJTEVTID0gJ1dFQl9DSEFUL1NFTkRfRklMRVMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kRmlsZXMoZmlsZXMpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX0ZJTEVTLFxuICAgIHBheWxvYWQ6IHsgZmlsZXMgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX0ZJTEVTIH07XG4iXX0=